/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Generator_NewInputs */

const en_directory_tools_generator_new = /** @type {(inputs: Directory_Tools_Generator_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const zh_directory_tools_generator_new = /** @type {(inputs: Directory_Tools_Generator_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新上线`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Directory_Tools_Generator_NewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_generator_new = /** @type {((inputs?: Directory_Tools_Generator_NewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Generator_NewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_generator_new(inputs)
	return zh_directory_tools_generator_new(inputs)
});
export { directory_tools_generator_new as "directory.tools.generator_new" }